module.exports = __webpack_public_path__ + "img/axelerate-logo-purple.bae74070.svg";